import React, { useState } from "react"

const UnlinkedFilter = () => {
  const [isUnlinkedFilterActive, setIsUnlinkedFilterActive] = useState(false)

  const handleToggle = () => {
    setIsUnlinkedFilterActive(!isUnlinkedFilterActive)
  }

  return (
    <div>
      <button
        type="button"
        className={`reconciliation-filter facetselector ui button ${
          isUnlinkedFilterActive ? "active" : ""
        }`}
        onClick={handleToggle}
      >
        <i className="unlink icon" />
        Unlinked Invoices
        {isUnlinkedFilterActive && (
        <i
          className="close icon close-buttonfilter"
          onClick={handleToggle}
          // setUnlinked = {(!unlinked) => {}}
          onChange={() => handleToggle()}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleToggle() }}
          role="button"
          tabIndex="0"
          aria-label="Fermer le bouton"
        />
        )}
      </button>
    </div>
  )
}

export default UnlinkedFilter
